export default __webpack_public_path__ + "static/media/relatedProgImg3.542fe23f.png";